import type { ReactNode, Ref, SVGAttributes } from 'react'
import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'
import type { IconOverrides } from 'baseui/icon'

export interface SDIconProps extends Omit<SVGAttributes<SVGElement>, 'color' | 'ref'> {
  color?: string
  defaultColorKey?: string
  hidden?: boolean
  overrides?: IconOverrides
  ref?: Ref<SVGSVGElement>
  size?: number
  title?: string
  viewBox?: string
}

const SDIcon = ({
  children,
  color,
  defaultColorKey,
  hidden,
  overrides,
  ref,
  size = 16,
  title,
  viewBox = '0 0 32 32',
  ...rest
}: SDIconProps & { children: ReactNode }) => {
  const [, theme] = useStyletron()

  if (hidden) return null

  const iconColor = color ?? (theme.colors as unknown as Record<string, string>)[defaultColorKey ?? 'primary']

  return (
    <Icon viewBox={viewBox} ref={ref} title={title} size={size} color={iconColor} overrides={overrides} {...rest}>
      {title && <title>{title}</title>}
      {children}
    </Icon>
  )
}

export default SDIcon
